
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 14.856s1.172.335 1.34-1.925h.083v-.25s.335-.67.335-.921V3.976s0-.418-.419-.67c0-.585.084-1.422-.084-1.757C8.505 1.131 8.588.126 7.5.126S6.496 1.214 6.245 1.55c-.168.335-.084 1.172-.084 1.758-.419.25-.419.67-.419.67v7.783c0 .25.335.92.335.92v.251h.084c.251 2.176 1.339 1.925 1.339 1.925z"}})])
          )
        }
      }
    